const routes = [
  {
    path: '/',
    component: 'pages/Home/Home',
  },
  {
    path: '/plans',
    component: 'pages/Plans/Plans',
  },
  {
    path: '/interiors',
    component: 'pages/Interiors/Interiors',
  },
  {
    path: '/neighbourhood',
    component: 'pages/Neighbourhood/Neighbourhood',
  },
  {
    path: '/amenities',
    component: 'pages/Amenities/Amenities',
  },
  {
    path: '/developer',
    component: 'pages/Developer/Developer',
  },
  {
    path: '/register',
    component: 'pages/Register/Register',
  },
  {
    path: '/about',
    component: 'pages/About',
  },
  {
    path: '/thankyou',
    component: 'pages/Thankyou/Thankyou',
  },
];

module.exports = routes;



// WEBPACK FOOTER //
// ./src/routes.js